export default {
    // 1: About
    'ABOUT': {
        en: 'ABOUT',
        es: 'ACERCA DE',
        pt: 'SOBRE'
    },
    'Música para Respirar': {
        en: 'Música para Respirar',
        es: 'Música para Respirar',
        pt: ''
    },
    'La Sociedad': {
        en: 'La Sociedad',
        es: 'La Sociedad',
        pt: ''
    },
    'LA SOCIEDAD': {
        en: 'LA SOCIEDAD',
        es: 'LA SOCIEDAD',
        pt: 'LA SOCIEDAD'
    },
    'Team': {
        en: 'Team',
        es: 'El Equipo',
        pt: 'Equipe'
    },
    'TEAM': {
        en: 'TEAM',
        es: 'EL EQUIPO',
        pt: ''
    },
    'Support': {
        en: 'Support',
        es: 'Apoyo',
        pt: ''
    },

    // 2: Request a concert
    'REQUEST A CONCERT': {
        en: 'REQUEST A CONCERT',
        es: 'PIDE TU CONCIERTO',
        pt: 'PEÇA SEU CONCERTO'
    },
    'Personal Concert': {
        en: 'Personal Concert',
        es: 'Conciertos personales',
        pt: ''
    },
    'Gift a Concert': {
        en: 'Gift a Concert',
        es: 'Conciertos de regalo',
        pt: ''
    },
    'Institutional Concerts': {
        en: 'Institutional Concerts',
        es: 'Conciertos institucionales',
        pt: ''
    },
    'Tips for your concert': {
        en: 'Tips for your concert',
        es: 'Tips para Concierto',
        pt: ''
    },

    // 3: Impact
    'IMPACT': {
        en: 'IMPACT',
        es: 'IMPACTO',
        pt: 'IMPACTO'
    },
    'Numbers': {
        en: 'Numbers',
        es: 'Cifras',
        pt: ''
    },
    'Map': {
        en: 'Map',
        es: 'Mapa',
        pt: ''
    },
    'Press': {
        en: 'Press',
        es: 'Prensa',
        pt: ''
    },
    'Reports': {
        en: 'Reports',
        es: 'Reportes',
        pt: ''
    },

    // 4: Media
    'MEDIA': {
        en: 'MEDIA',
        es: 'MEDIA',
        pt: 'GALERIA'
    },
    'Musicians': {
        en: 'Musicians',
        es: 'Artistas',
        pt: 'Artistas'
    },
    'MUSICIANS': {
        en: 'MUSICIANS',
        es: 'ARTISTAS',
        pt: 'ARTISTAS'
    },
    'Pictures': {
        en: 'Pictures',
        es: 'Fotos',
        pt: ''
    },
    'Videos': {
        en: 'Videos',
        es: 'Videos',
        pt: ''
    },

    // 5: Support us
    'SUPPORT US': {
        en: 'SUPPORT US',
        es: 'CONTRIBUYE',
        pt: 'CONTRIBUA'
    },

    // 6: Contact us
    'CONTACT US': {
        en: 'CONTACT US',
        es: 'CONTACTO',
        pt: 'CONTATO'
    },
    'Email': {
        en: 'Email',
        es: 'Email',
        pt: ''
    },
    'Facebook': {
        en: 'Facebook',
        es: 'Facebook',
        pt: ''
    },
    'Instagram': {
        en: 'Instagram',
        es: 'Instagram',
        pt: ''
    },
    'Twitter': {
        en: 'Twitter',
        es: 'Twitter',
        pt: ''
    },
    'currentLanguage': {
        en: 'English',
        es: 'Español',
        pt: 'Português'
    },
    'LANGUAGE': {
        en: "LANGUAGE",
        es: "IDIOMA",
        pt: "IDIOMA"
    },
    'Back': {
        en: "Back",
        es: "Regresar",
        pt: "Voltar"
    }
}
